import React, { useState, useEffect } from 'react';
import { Globals as OldGlobals } from '../../global/Globals';
import DropdownList from '../../components/DropdownList/DropdownList';
import FileUploader from '../../components/FileUploader/FileUploader';
import TextArea from '../../components/TextArea/TextArea';
import RegisterHeader from '../../components/RegisterHeader/RegisterHeader';
import RegisterFooter from '../../components/RegisterFooter/RegisterFooter';
import Popup from '../../components/PopUp/PopUp';
import './Company_reg.css';
import { useDispatch, useSelector } from 'react-redux';
import {
    setAllChannels, setAllGeners, setAllLanguages, setAllCountries, setProvience,
    setSelectedData, removeSelectedData, removeAllData, setAllFormats, setAllProdType, clearAllFormats, clearAllChannels, clearAllProdTypes, clearAllCountries
} from './ProducerRegistrationSlice';
import { fetchProvienceByCountry, fetchAllCountries, fetchByfilter, fetchEmail, validateProducerMandatoryFields } from '../../services/GenericAPI';
import { useNavigate } from 'react-router-dom';
import TermsConditions from '../../components/TermsConditions/TermsConditions';
import TitledCheckedDropDown from '../../components/TitledCheckedDropDown/TitledCheckedDropDown';
import { registration } from '../../services/Registration';
import ConditionalUpload from '../../components/ConditionalUpload/ConditionalUpload';
import { validateEmail, validatePhoneNumber, checkEmailExistance, validateName, validateWebsite, validateSocialMediaLinks } from '../../util/util';
import { removeAllCheck } from '../../components/TermsConditions/TermsConditionsSlice';
import ProgressLoader from '../../components/ProgressLoader/ProgressLoader';
import { useLanguage } from '../../context/Languagecontext';
const CompanyRegistration = () => {
    const { Globals } = useLanguage();
    let countriesList = [];
    const [socialLinks, setSocialLinks] = useState(['']);
    const [title, setTitle] = useState('');
    const [address, setAddress] = useState('');
    const [provience, setProvience] = useState('');
    const [country, setCountry] = useState('');
    const [website, setWebSite] = useState('');
    const [isKeyContactEmailInvalid, setIsKeyContactEmailInvalid] = useState(false);
    const [isCompanyEmailInvalid, setIsCompanyEmailInvalid] = useState(false);
    const [isCompanyPhoneNumInValid, setIsCompanyPhoneNumInValid] = useState(false);
    const [isKeyContactEmailExist, setIsKeyContactEmailExist] = useState(false);
    const [isKeyContactNameInvalid, setIsKeyContactNameInvalid] = useState(false);
    const [isCompanyNameInvalid, setIsCompanyNameInvalid] = useState(false);
    const [isWebSiteInvalid, setIsWebSiteInvalid] = useState(false);
    const [loading,setLoading]=useState(false)
    const [isSocialMediaInvalid, setIsSocialMediaInvalid] = useState(
        new Array(socialLinks.length).fill(false)
    );
    const [areTermsAgreed, setTermsAgreed] = useState(false);
    const [countSelection, setCountSelection] = useState('');
    const [provincesList, setProvincesList] = useState([]);
    const [provicesDetails, setProvicesDetails] = useState([]);
    const [isRegCanceled, setRegCancel] = useState(false);
    const [isRegSuccess, setRegSuccess] = useState(false);
    const [isRegFailed, setRegFailure] = useState(false);
    const [isVendorRegistered, setVendorRegistered] = useState(false);
    const [isTaxClearance, setTaxClearance] = useState(false);
    const [isBBEECompliant, setBBEECompliant] = useState(false);
    const [companyName, setCompanyName] = useState('');
    const [companyRegNum, setCompanyRegNum] = useState('');
    const [keyContactName, setKeyContactName] = useState('');
    const [keyContactEmail, setKeyContactEmail] = useState('');
    const [vatRegNum, setVatRegNum] = useState('');
    const [venRegNum, setVenRegNum] = useState('');
    const [isVatRegNumInvalid, setIsVatRegNumInvalid] = useState(false);
    const [isVatRegNumExists, setIsVatRegNumExists] = useState(false)
    const [isVenRegNumInvalid, setIsVenRegNumInvalid] = useState(false);
    const [isVenRegNumExists, setIsVenRegNumExists] = useState(false)
    const [isVendorRegNum, setIsVendorRegNum] = useState(false);
    const [companyContactNum, setCompanyContactNum] = useState('');
    const [companyEmail, setCompanyEmail] = useState('');
    const [isTitleNotSelected, setTitleNotSelected] = useState(false);
    const [isCompanyRegNumEmpty, setIsCompanyRegNumEmpty] = useState(false);
    const [isCompanyEmailTouched, setIsCompanyEmailTouched] = useState(false);
    const [isKeyContactEmailTouched, setKeyContactEmailTouched] = useState(false);
    const [isCompanyRegNumExists, setIsCompanyRegNumExists] = useState(false);
    const [isCompanyNameExists, setIsCompanyNameExists] = useState(false);
    const [logoFile, setLogoFile]=useState(null);
    const [taxClrnceCertfile, setTaxClrnceCertfile]=useState(null);
    const [bbbEEfile, setBBBEEfile]=useState(null);
    const [isFileSelected, setFileSelected]=useState({
        taxFile:undefined, bbeeFile:undefined
    })
    const [vendorRegControls, setVendorRegControls]=useState({
        vatCert:null,
        vat103:null,
        taxInvoice:null,
        regDocs:null,
        bbbeeCert:null,
        bankStamped:null
    })
    const allChannelsData = useSelector(state => state.producerRegistration.allChannels);
    const allLanguagesData = useSelector(state => state.producerRegistration.allLanguages);
    const allGenersData = useSelector(state => state.producerRegistration.allGeners);
    const allCountriesDetails = useSelector(state => state.producerRegistration.allCountries);
    const allCountriesData = useSelector(state => state.producerRegistration.allCountries.map(ele => ele.countryName));
    const isAgreementChecked = useSelector(state => state.termsConditions.isAgreementChecked);
    const isPolicyChecked = useSelector(state => state.termsConditions.isPolicyChecked);
    const isConfidentialInfoChecked = useSelector(state => state.termsConditions.isConfidentialInfoChecked);
    const countries = useSelector(state => state.producerRegistration.allCountries);
    const selectedLanguagesList = useSelector(state => state.producerRegistration.selectedLanguages);
    const selectedGenresList = useSelector(state => state.producerRegistration.selectedGenres);
    const selectedChannelsList = useSelector(state => state.producerRegistration.selectedChannels);
    const allFormatsData = useSelector(state => state.producerRegistration.allFormats);
    const allProdTypesData = useSelector(state => state.producerRegistration.allProdTypes);
    const selectedFormatsList = useSelector(state => state.producerRegistration.selectedFormat);
    const selectedProdTypeList = useSelector(state => state.producerRegistration.selectedProdType);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const addSocialLink = () => {
        setSocialLinks([...socialLinks, '']);
        setIsSocialMediaInvalid([...isSocialMediaInvalid, false]);
    };

    const removeSocialLink = (index) => {
        const updatedLinks = socialLinks.filter((_, i) => i !== index);
        setSocialLinks(updatedLinks);

        // Clear invalid state for the removed input
        const updatedInvalidState = isSocialMediaInvalid.filter((_, i) => i !== index);
        setIsSocialMediaInvalid(updatedInvalidState);

        // You can also reset the error state if needed when no social link exists
        if (updatedLinks.length === 0) {
            setIsSocialMediaInvalid([false]);
        }
    };

    const [_navigated, setNavigated] = useState(false);
    
      useEffect(() => {
        const handlePopstate = (event) => {
          if (_navigated) {
            setNavigated(false);
            return;
          }
          setRegCancel(true);
        };
    
        window.addEventListener('popstate', handlePopstate);
    
        // Initial pushState to ensure we catch the first navigation attempt
        window.history.pushState(null, null, window.location.href);
    
        return () => {
          window.removeEventListener('popstate', handlePopstate);
        };
      }, [_navigated]);

    useEffect(() => {
        if (allLanguagesData || allLanguagesData?.length === 0) {
            fetchByfilter(OldGlobals.FILTER_OPTIONS_NAME.LANGUAGE).then((response) => {
                dispatch(setAllLanguages({ allLanguages: response.data.content["Languages"] }));
            })
        }
        if (allGenersData || allGenersData?.length === 0) {
            fetchByfilter(OldGlobals.FILTER_OPTIONS_NAME.GENRE).then((response) => {
                dispatch(setAllGeners({ allGeners: response.data.content["Genres"] }));
            })
        }
        if (allChannelsData?.length === 0) {
            fetchByfilter(OldGlobals.FILTER_OPTIONS_NAME.CHANNEL).then((response) => {
                dispatch(setAllChannels({ allChannels: response.data.content["Channels"] }));
            })
        }
        if (allCountriesData?.length === 0) {
            fetchAllCountries().then((response) => {
                dispatch(setAllCountries({ allCountries: response.data.content }));
                countriesList = response.data.content.map(country => country.countryName)
            }).catch((error) => {
                console.error(Globals.ERROR_MESSAGES.GENERIC_API_ERROR, error);
            });
        }

        if (allFormatsData?.length === 0) {
            fetchByfilter(OldGlobals.FILTER_OPTIONS_NAME.FORMAT).then((response) => {
                dispatch(setAllFormats({ allFormats: response.data.content[OldGlobals.FILTER_OPTIONS_NAME.FORMAT] }));
            })
        }
        if (allProdTypesData?.length === 0) {
            fetchByfilter(OldGlobals.FILTER_OPTIONS_NAME.TYPE).then((response) => {
                dispatch(setAllProdType({ allProdTypes: response.data.content[OldGlobals.FILTER_OPTIONS_NAME.TYPE] }));
            })
        }
    }, []);

    const handleTitleSelection = (event) => {
        setTitleNotSelected(false);
        setTitle(event);
    }

    const handleCompanyName = (event) => { setIsCompanyNameInvalid(false);
        setIsCompanyNameExists(false);setCompanyName(event.target.value); }//checkCompanyName(); 
    const handleCompanyRegNum = (event) => {setIsCompanyRegNumEmpty(false); setIsCompanyRegNumExists(false); setCompanyRegNum(event.target.value); }
    const handleKeyContactName = (event) => { checkTitle(); setIsKeyContactNameInvalid(false); setKeyContactName(event.target.value); }//checkKeyName()
    const handleKeyContactEmail = (event) => {
        setIsKeyContactEmailExist(false);
        setIsKeyContactEmailInvalid(false);
        setKeyContactEmail(event.target.value);
    }
    const handleVatRegNum = (event) => { setIsVatRegNumExists(false); setIsVatRegNumInvalid(false); setVatRegNum(event.target.value); }
    const handleVenRegNum = (event) => { setIsVenRegNumExists(false); setIsVatRegNumInvalid(false); setVenRegNum(event.target.value); }
    const handleCompanyContactNum = (event) => {
        setIsCompanyPhoneNumInValid(false);
        const phNum = event.target.value;
        setCompanyContactNum(phNum);

        { phNum.length > 0 ? setIsCompanyPhoneNumInValid(!validatePhoneNumber(phNum)) : setIsCompanyPhoneNumInValid(false) }
        // if (phNum.length === 0) {
        //     console.log("checkifphone",phNum.length);
        //     setIsCompanyPhoneNumInValid(false);
        //     return;
        // }
        // else {
        //     setIsCompanyPhoneNumInValid(!validatePhoneNumber(phNum));
        // }
    }
    const handleCompanyEmail = (event) => {
        setIsCompanyEmailInvalid(false);
        setCompanyEmail(event.target.value);
    }

    const handleAddress = (event) => { setAddress(event); }

    const handleProvience = (event) => {
        const provienceID = provicesDetails.find(item => item.provinceName === event).provinceId;
        setProvience(provienceID);
    }

    const handleCountry = (event) => {
        const countryId = allCountriesDetails.find(item => item.countryName === event).countryId;
        setCountry(countryId);
        setBBEECompliant(false);

        fetchProvienceByCountry(countries, event).then((response) => {
            setProvicesDetails(response.data.content);
            setProvincesList(response.data.content.map(prov => prov.provinceName));
            dispatch(setProvience({ provience: response.content.map(prov => prov.provinceName) }))
        }).catch((error) => {
            console.error(Globals.ERROR_MESSAGES.GENERIC_API_ERROR, error);
        });
    }

    const handleWebSite = (event) => {
        setIsWebSiteInvalid(false);
        setWebSite(event.target.value);
    }

    const handleSocialMedia = (index, event) => {
        const newSocialLinks = [...socialLinks];
        newSocialLinks[index] = event.target.value;
        setSocialLinks(newSocialLinks);
    };
    const processUserRegsitartion = () => {
        const requestObj = {
            producerType: Globals.SIGNUP.TYPE.COMPANY,
            companyName: companyName,
            companyRegNo: companyRegNum,
            title: title,
            vatRegistrationNumber: vatRegNum,
            vendorRegistrationNumber: venRegNum,
            isTaxClearanceCertificate: vendorRegControls.vatCert ? true : false,
            isBBBEE: vendorRegControls.bbbeeCert ? true : false,
            IsTaxInvoiceorSampleInvoice: vendorRegControls.taxInvoice ? true : false,
            IsRegistrationDocumentsorCertifiedCopyOfID: vendorRegControls.regDocs ? true : false,
            IsBankStampedLetterorCancelledCheque: vendorRegControls.bankStamped ? true : false,
            IsVat103IfNoVatNumberInTcc: vendorRegControls.vat103 ? true : false,
            companyContactNumber: companyContactNum,
            businessAddress: address,
            companyEmail: companyEmail,
            language: selectedLanguagesList,
            genre: selectedGenresList,
            channels: selectedChannelsList,
            formats: selectedFormatsList,
            productionTypes: selectedProdTypeList,
            website: website,
            socialMediaLinks: socialLinks.toString(),
            country: country ? country : 0,
            provience: provience ? provience : 0,
            email: keyContactEmail,
            name: keyContactName,
            isVendorRegistered:isVendorRegistered,
            logofile:logoFile,
            TaxClrnceCertfile:isTaxClearance?taxClrnceCertfile:null,
            BBBEEfile:isBBEECompliant?bbbEEfile:null,
            isConsent: isConfidentialInfoChecked === true ? true : false,
            TaxClrnceCertfile: vendorRegControls.vatCert,
            BBBEEfile: vendorRegControls.bbbeeCert,
            TaxInvoiceorSampleInvoice: vendorRegControls.taxInvoice,
            RegistrationDocumentsorCertifiedCopyOfID: vendorRegControls.regDocs,
            BankStampedLetterorCancelledCheque: vendorRegControls.bankStamped,
            Vat103IfNoVatNumberInTcc: vendorRegControls.vat103
        }
        setLoading(true)
        registration(requestObj).then((response) => {
            setLoading(false)
            if(response.data.status!=="OK"){setRegFailure(true);}
            else if (response.data.content) {
                setRegSuccess(true);
            }
            else {
                setRegFailure(true);
            }
        }).catch((error) => {
            setLoading(false)
            console.error("Registraion Failed", error);
            setRegFailure(true);
        })
    }

    const cancelRegistration = () => {
        setRegCancel(true);
    }

    const navigateBackToSignUp = () => { navigate(Globals.NAVPATH.SIGNUP); }
    const navigateToLogin = () => { navigate(Globals.NAVPATH.ROOT); }
    const handleAggreement = (areBothChecked) => { }

    const validateCompanyEmail = () => {
        setIsCompanyEmailTouched(true);
        if (companyEmail.length === 0) {
            setIsCompanyEmailInvalid(false);
        }
        else {
            const isValid = validateEmail(companyEmail);
            isValid ? setIsCompanyEmailInvalid(false) : setIsCompanyEmailInvalid(true);
        }
    }

    const handleSelectAllGenres = (e) => {
        e ? allGenersData.map((item) => {
            dispatch(setSelectedData({ option: "Genres", element: item.id }))
        }) : dispatch(removeAllData({ option: "Genres" }))
    }
    const handleSelectedGenreValues = (genreId) => {
        selectedGenresList.find(item => item.genreId === genreId) ?
            dispatch(removeSelectedData({ option: "Genres", element: genreId })) :
            dispatch(setSelectedData({ option: "Genres", element: genreId }))
    }

    const handleSelectedLanguageValues = (langId) => {
        selectedLanguagesList.find(item => item.languageId === langId) ?
            dispatch(removeSelectedData({ option: "Languages", element: langId })) :
            dispatch(setSelectedData({ option: "Languages", element: langId }))
    }

    const handleSelectAllLanguages = (e) => {
        e ? allLanguagesData.map((item) => {
            dispatch(setSelectedData({ option: "Languages", element: item.id }))
        }) : dispatch(removeAllData({ option: "Languages" }))
    }

    const handleSelectedChannelValues = (channelId) => {
        selectedChannelsList.find(item => item.channelId === channelId) ?
            dispatch(removeSelectedData({ option: "Channels", element: channelId })) :
            dispatch(setSelectedData({ option: "Channels", element: channelId }))
    }

    const handleSelectAllChannels = (e) => {
        e ? allChannelsData.map((item) => {
            dispatch(setSelectedData({ option: "Channels", element: item.id }))
        }) : dispatch(removeAllData({ option: "Channels" }))
    }

    const handleSelectAllFormats = (e) => {
        e ? allFormatsData.map((item) => {
            dispatch(setSelectedData({ option: "Formats", element: item.id }))
        }) : dispatch(removeAllData({ option: "Formats" }))
    }
    const handleSelectedFormatValues = (formatId) => {

        selectedFormatsList.find(item => item.formatId === formatId) ?
            dispatch(removeSelectedData({ option: "Formats", element: formatId })) :
            dispatch(setSelectedData({ option: "Formats", element: formatId }))
    }
    const handleSelectAllProdTypes = (e) => {
        e ? allProdTypesData.map((item) => {
            dispatch(setSelectedData({ option: "ProdTypes", element: item.id }))
        }) : dispatch(removeAllData({ option: "ProdTypes" }))
    }
    const handleSelectedProdTypeValues = (prodTypeId) => {
        selectedProdTypeList.find(item => item.productionTypeId === prodTypeId) ?
            dispatch(removeSelectedData({ option: "ProdTypes", element: prodTypeId })) :
            dispatch(setSelectedData({ option: "ProdTypes", element: prodTypeId }))
    }
    const handleTaxClearance = (event) => { setTaxClearance(event); !isTaxClearance&&setTaxClrnceCertfile(null);}
    const handleBBEECompliant = (event) => { setBBEECompliant(event); !isBBEECompliant&&setBBBEEfile(null);  }
    const handleVendorReg = (event) => { if(event==='No'){setIsVenRegNumInvalid(false); setIsVenRegNumExists(false); setVenRegNum('');}setVendorRegistered(event);}

    const clearCheckedList = () => {
        dispatch(removeAllData({ option: "Channels" }));
        dispatch(removeAllData({ option: "Languages" }));
        dispatch(removeAllData({ option: "Genres" }));
        dispatch(removeAllData({ option: "Formats" }));
        dispatch(removeAllData({ option: "ProdTypes" }));
        dispatch(removeAllCheck());
        dispatch(clearAllFormats());
        dispatch(clearAllProdTypes());
        dispatch(clearAllChannels());
        dispatch(clearAllCountries());
    }

    const checkForEmail = () => {
        setKeyContactEmailTouched(true);
        setIsKeyContactEmailExist(false);
        setIsKeyContactEmailInvalid(false);
        if (keyContactEmail.length === 0) {
            setIsKeyContactEmailExist(false);
            setIsKeyContactEmailInvalid(true);
        }
        else {
            const regex = OldGlobals.REGEX.EMAIL_REGEX;
            const isValid = regex.test(keyContactEmail);
            if (isValid) {
                fetchEmail(keyContactEmail).then((response) => {
                    response.data.exists ? setIsKeyContactEmailExist(true) : setIsKeyContactEmailExist(false);
                }).catch((error) => { console.error(Globals.ERROR_MESSAGES.GENERIC_API_ERROR, error) })
            }
            else {
                setIsKeyContactEmailInvalid(!isValid);
            }
        }
    }

    const checkKeyName = () => {
        setIsKeyContactNameInvalid(false);
        setIsKeyContactNameInvalid(false);
        const isValid = validateName(keyContactName);
        isValid ? setIsKeyContactNameInvalid(!isValid) : setIsKeyContactNameInvalid(true);
    }

    const checkCompanyName = async () => {
        setIsCompanyNameInvalid(false);
        setIsCompanyNameExists(false);
        const isValid = companyName.length > 0;
        const response = await validateProducerMandatoryFields(Globals.PRODUCER_MANDATORY_FIELDS_API_KEYS.COMPANY_NAME, companyName)
        if (isValid && response) {
            setIsCompanyNameInvalid(false);
            setIsCompanyNameExists(true);
        }
        else if(!isValid){
            setIsCompanyNameInvalid(true);
            setIsCompanyNameExists(false);
        }
         else {
            setIsCompanyNameInvalid(false);
            setIsCompanyNameExists(false);
        }
    };


    const resetCheckBox = () => {
        dispatch(removeAllCheck());
    }

    const handleVendorRegNumber = (val) => {
        setIsVenRegNumExists(false);
        setIsVenRegNumInvalid(false);
        setVenRegNum('');
        setIsVendorRegNum(!val);
    }
    const checkCompanyContactNumber = () => {
        // if (companyContactNum.trim() === "") {
        //     setIsCompanyPhoneNumInValid(true)
        // }
        if(companyContactNum.length>0) {
            const res = validatePhoneNumber(companyContactNum);
            setIsCompanyPhoneNumInValid(!res);
        }
    }
    const checkCompanyRegNum = async () => {
        setIsCompanyRegNumEmpty(false);
        setIsCompanyRegNumExists(false);
        const response = await validateProducerMandatoryFields(Globals.PRODUCER_MANDATORY_FIELDS_API_KEYS.COMPANY_REG_NUM, companyRegNum);
        if (companyRegNum.length < 7 || companyRegNum.length > 20) {
            setIsCompanyRegNumEmpty(true);
        }
        else {
            setIsCompanyRegNumEmpty(false)
            if (response) {
                setIsCompanyRegNumExists(true);
            }
            else {
                setIsCompanyRegNumExists(false);
                setIsCompanyRegNumEmpty(false)
            }
        }
    }
    const checkVatRegNum = async () => {
        setIsVatRegNumInvalid(false);
        const response = vatRegNum.length >0 && await validateProducerMandatoryFields(Globals.PRODUCER_MANDATORY_FIELDS_API_KEYS.VAT_REG_NUM, vatRegNum)
        if ((vatRegNum.length >0 && vatRegNum.length < 7) || vatRegNum.length > 14) {
            setIsVatRegNumInvalid(true);
        } else {
            setIsVatRegNumInvalid(false);
            if (response) {
                setIsVatRegNumExists(true);
            } else {
                setIsVatRegNumExists(false);
                setIsVatRegNumInvalid(false);
            }
        }
    }
    const checkVenRegNum = async () => {
        //setIsVenRegNumInvalid(false);
        setIsVenRegNumExists(false);
        const response = await validateProducerMandatoryFields(Globals.PRODUCER_MANDATORY_FIELDS_API_KEYS.VEN_REG_NUM, venRegNum)
        //if (venRegNum.length < 7 || venRegNum.length > 14) {
            //setIsVenRegNumInvalid(true);
       // } else {
          //  setIsVenRegNumInvalid(false);
           // setIsVenRegNumExists(false);
            if (response) {
                setIsVenRegNumExists(true);
            } else {
                setIsVenRegNumExists(false);
                //setIsVenRegNumInvalid(true);
            }
        //}
    }

    const handleLogoFileInput=(file)=>{
        setLogoFile(file);
    }

    const handleTaxCertificateFileInput = (file) => {
        setTaxClrnceCertfile(file);
    }

    const handleBBEEEFileInput=(file)=>{
        setBBBEEfile(file);
    }

    const [isTaxFilePresent, setTaxFilePresent] = useState();
    const [isBBBEEFilePresent, setBBBEEFilePresent] = useState();
    useEffect(() => {
        if (isTaxClearance && taxClrnceCertfile) {
            setTaxFilePresent(true);
        }
        else if (isTaxClearance && !taxClrnceCertfile) {
            setTaxFilePresent(false);
        }
        else {
            setTaxFilePresent(undefined);
        }
    }, [isTaxClearance, taxClrnceCertfile])

    useEffect(() => {
        if (isBBEECompliant && bbbEEfile) {
            setBBBEEFilePresent(true);
        }
        else if (isBBEECompliant && !bbbEEfile) {
            setBBBEEFilePresent(false);
        }
        else {
            setBBBEEFilePresent(undefined);
        }
    }, [isBBEECompliant, bbbEEfile])

    const handleVendorRegControls=(fieldName, file)=>{
        setVendorRegControls((prevState) => ({
            ...prevState,
            [fieldName]: file
        }));
    }

    const checkTitle = () => { title.trim() === "" ? setTitleNotSelected(true) : setTitleNotSelected(false); }
    const isFormValid =
        title.trim() !== '' &&
        companyName.trim() !== '' &&
        companyRegNum.trim() !== '' &&
        keyContactName.trim() !== '' &&
        keyContactEmail.trim() !== '' &&
        isAgreementChecked === true &&
        isPolicyChecked === true &&
        isConfidentialInfoChecked===true &&
        !isKeyContactEmailExist &&
        !isKeyContactEmailInvalid &&
        !isCompanyEmailInvalid &&
        !isCompanyPhoneNumInValid &&
        isSocialMediaInvalid.every(value => value === false) &&
        !isWebSiteInvalid &&
        !isCompanyNameInvalid &&
        !isTitleNotSelected &&
        !isKeyContactEmailInvalid &&
        !isKeyContactNameInvalid &&
        !isCompanyPhoneNumInValid &&
        !isCompanyEmailInvalid &&
        !isVenRegNumExists&&
        !isVenRegNumInvalid&&
        !isVatRegNumExists&&
        !isVatRegNumInvalid&&
        !isCompanyNameExists&&
        !isCompanyRegNumExists&&
        // (isTaxFilePresent!==false)&&
       // (isBBBEEFilePresent!==false)&&
        ((isVendorRegistered && venRegNum.length>0)||!isVendorRegistered);

    return (
        <div id="register-container" className="register-container">
            <RegisterHeader onCancelRegister={cancelRegistration} title={Globals.SIGNUP.COMPANY} />
            <div id="register-form" className="register-form">
                <div id="register-form-content" className="register-form-content">
                    <h3 id="basic-info" className="basic-info">{Globals.SIGNUP.COMPANY_INFO}</h3>
                    <div id="row-content" className="row-1-content">
                        <div id="company-name-holder">
                            <label id="company-name" className="company-name">{Globals.SIGNUP.COMPANY_NAME_LABEL}<span id="mandatory" className="mandatory">{Globals.MANDATORY_FIELD}</span></label>
                            <input type="text" id="company-name-inp" className={`company-name-inp ${companyName && companyName.length > 0 ? "hightlight" : ""}`} placeholder={Globals.SIGNUP.COMPANY_PLACEHOLDERS.COMPANY_NAME} onChange={handleCompanyName} tabIndex={1} onBlur={checkCompanyName} maxLength={30} autoComplete='off'></input>
                            { (isCompanyNameInvalid || isCompanyNameExists) && <div><img id="login-error" className="login-error" src={Globals.IMG.ERROR} alt="password error" /><label className='invalidCredential'>{companyName.length===0?Globals.ERROR_MESSAGES.EMPTY_COMPANY_NAME : Globals.ERROR_MESSAGES.COMPANY_NAME_EXISTS}</label></div>}
                        </div>
                        <div id="company-reg-num-holder">
                            <label id="company-reg-num" className="company-reg-num">{Globals.SIGNUP.COMPANY_REG_NUMBER_LABEL}<span id="mandatory" className="mandatory">{Globals.MANDATORY_FIELD}</span></label>
                            <input type="text" id="company-reg-num-inp" className={`company-reg-num-inp ${companyRegNum && companyRegNum.length > 0 ? "hightlight" : ""}`} placeholder={Globals.SIGNUP.COMPANY_PLACEHOLDERS.COMPANY_REG_NUMBER} onChange={handleCompanyRegNum} onBlur={checkCompanyRegNum} tabIndex={2} maxLength={20} minLength={7} autoComplete='off'></input>
                            {(isCompanyRegNumEmpty || isCompanyRegNumExists) && <div><img id="login-error" className="login-error" src={Globals.IMG.ERROR} alt="password error" /><label className='invalidCredential'>{(companyRegNum.length === 0) ? Globals.ERROR_MESSAGES.EMPTY_COMPANY_REG_NO : companyRegNum.length>0 && companyRegNum.length<7?Globals.ERROR_MESSAGES.INVALID_COMPANY_REG_NO:
                            Globals.ERROR_MESSAGES.COMPANY_REG_NUM_EXISTS}</label></div>}
                        </div>
                        <div id="company-logo-pic-holder">
                            <label id="company-logo-pic" className="company-logo-pic">{Globals.SIGNUP.COMPANY_LOGO_LABEL}</label>
                            <span tabIndex={3}><FileUploader onFileUpload={(file)=>handleLogoFileInput(file)} supportedFileType="ImagesOnly" isFromRegPage={true} isLogoHolder={true}/></span>
                        </div>
                    </div>
                    <div id="row-content" className="row-1-content">
                        <div id="title-holder">{/** company title holder */}
                            <label id="user-title" className="user-title">{Globals.SIGNUP.TITLE}<span id="mandatory" className="mandatory">{Globals.MANDATORY_FIELD}</span></label>
                            <span className="comp-titles-list" tabIndex={4} onBlur={checkTitle}><DropdownList options={Globals.SIGNUP.TITLES_LIST} placeHolderValue={Globals.SIGNUP.TITLES_INP_PLACEHOLDER} onSelect={handleTitleSelection} selectClass={title && "hightlight"} /></span>
                            {isTitleNotSelected && <div><img id="login-error" className="login-error" src={Globals.IMG.ERROR} alt="password error" /><label className='invalidCredential'>{Globals.ERROR_MESSAGES.UNSELECTED_TITLE}</label></div>}
                        </div>
                        <div id="name-holder">{/** key contact name holder */}
                            <label id="name" className="name">{Globals.SIGNUP.KEY_CONTACT_NAME_LABEL}<span id="mandatory" className="mandatory">{Globals.MANDATORY_FIELD}</span></label>
                            <input tabIndex={5} type="text" id="name-inp" className={`name-inp ${keyContactName && keyContactName.length > 0 ? "hightlight" : ""}`} placeholder={Globals.SIGNUP.COMPANY_PLACEHOLDERS.KEY_CONTACT_NAME} onChange={handleKeyContactName} maxLength={30} onBlur={checkKeyName} autoComplete='off' ></input>{/**checkKeyName */}
                            {isKeyContactNameInvalid && <div><img id="login-error" className="login-error" src={Globals.IMG.ERROR} alt="password error" /><label className='invalidCredential'>{keyContactName.length === 0 ? Globals.ERROR_MESSAGES.EMPTY_KEY_CONTACT_NAME : Globals.ERROR_MESSAGES.INVALID_NAME}</label></div>}
                        </div>
                        <div id="email-holder">{/** key contact email holder */}
                            <label id="email" className="email">{Globals.SIGNUP.KEY_CONTACT_MAIL_LABEL}<span id="mandatory" className="mandatory">{Globals.MANDATORY_FIELD}</span></label>
                            <input type="email" id="email-input" className={`email-input ${keyContactEmail && keyContactEmail.length > 0 ? "hightlight" : ""}`} placeholder={Globals.SIGNUP.COMPANY_PLACEHOLDERS.KEY_CONTACT_MAIL} onChange={handleKeyContactEmail} onBlur={checkForEmail} tabIndex={6} autoComplete='off'></input>
                            {(isKeyContactEmailExist || isKeyContactEmailInvalid) && <div><img id="login-error" className="login-error" src={Globals.IMG.ERROR} alt="password error" /><label className='invalidCredential'>
                                {keyContactEmail.length === 0 ? Globals.ERROR_MESSAGES.REG_EMPTY_EMAIL :
                                    isKeyContactEmailInvalid ? Globals.ERROR_MESSAGES.REG_INVALID_EMAIL :
                                        Globals.ERROR_MESSAGES.EMAIL_EXIST}
                            </label></div>}
                        </div>
                    </div>
                    <div id='website-holder'>
                        <label id="website" className="website">{Globals.SIGNUP.WEBSITE}</label>
                        <input type="url" id="website-inp" className={`website-inp ${website && website.length > 0 ? "hightlight" : ""}`} placeholder={Globals.SIGNUP.WEBSITE_PLACEHOLDER} onChange={handleWebSite} tabIndex={7} autoComplete='off'></input>
                        {/* {isWebSiteInvalid && <div><img id="login-error" className="login-error" src={Globals.IMG.ERROR} alt="password error" /><label className='invalidCredential'>{Globals.ERROR_MESSAGES.INVALID_WEBSITE}</label></div>} */}
                    </div>
                    <div id="social-media-holder">
                        <label id="social-media" className="social-media">{Globals.SIGNUP.SOCIAL_MEDIA}</label>
                        {socialLinks.map((link, index) => (
                            <div className="reg-comp-social-media-default-inp" style={{ display: 'flex' }}>
                                <div id="social-media-section" className="social-media-section">
                                    <input
                                        key={index}
                                        value={link}
                                        type="url"
                                        id="reg-comp-social-media-inp"
                                        className={`reg-comp-social-media-inp ${socialLinks[index].length > 0 ? "hightlight" : ""}`}
                                        placeholder={Globals.SIGNUP.SOCIAL_MEDIA_PLACEHOLDER}
                                        onChange={(event) => handleSocialMedia(index, event)}
                                    />
                                    {/* {console.log(`isSocialMediaInvalid[${index}]`, isSocialMediaInvalid[index])}
                                    {isSocialMediaInvalid[index] === true && (
                                        <div>
                                            <img
                                                id="login-error"
                                                className="login-error"
                                                src={Globals.IMG.ERROR}
                                                alt="password error"
                                            />
                                            <label className="invalidCredential">{Globals.ERROR_MESSAGES.INVALID_SOCIAL_MEDIA_LINKS}</label>
                                        </div>
                                    )} */}
                                </div>
                                {index > 0 && (
                                    <button
                                        type="button"
                                        className="remove-social-link"
                                        onClick={() => removeSocialLink(index)}
                                    />
                                )}
                            </div>
                        ))}
                        {socialLinks.length < 3 ? (
                            <button
                                type="button"
                                id="reg-comp-add-social-link"
                                className="reg-comp-add-social-link"
                                onClick={addSocialLink}
                            >
                                {Globals.SIGNUP.ADD_MORE_LINKS}
                            </button>
                        ) : (
                            <button
                                type="button"
                                id="reg-comp-add-social-link-disabled"
                                className="reg-comp-add-social-link-disabled"
                                disabled={true}
                            >
                                {Globals.SIGNUP.ADD_MORE_LINKS}
                            </button>
                        )}
                    </div>
                    <div id="row-content" className="row-1-content">
                        <div id="genre-holder">
                            <label id="genre" className="genre">{Globals.SIGNUP.GENRE}</label>
                            <span tabIndex={8}><TitledCheckedDropDown
                                title={Globals.SIGNUP.GENRE_PLACEHOLDER}
                                options={allGenersData}
                                onSelectAll={handleSelectAllGenres}
                                onSelect={handleSelectedGenreValues}
                                selectedValues={selectedGenresList}
                                selectClass={selectedGenresList.length > 0 ? "hightlight" : ""}
                            /></span>
                        </div>
                        <div id="language-holder">
                            <label id="language" className="language">{Globals.SIGNUP.LANGUAGE}</label>
                            <span tabIndex={9}><TitledCheckedDropDown
                                title={Globals.SIGNUP.LANGUAGE_PLACEHOLDER}
                                options={allLanguagesData}
                                onSelectAll={handleSelectAllLanguages}
                                onSelect={handleSelectedLanguageValues}
                                selectedValues={selectedLanguagesList}
                                selectClass={selectedLanguagesList.length > 0 ? "hightlight" : ""}
                            /></span>
                        </div>
                        <div id="format-holder">
                            <label id="format" className="format">{Globals.SIGNUP.FORMAT_LABEL}</label>
                            <span tabIndex={10}><TitledCheckedDropDown
                                title={Globals.SIGNUP.COMPANY_PLACEHOLDERS.FORMAT}
                                options={allFormatsData}
                                onSelectAll={handleSelectAllFormats}
                                onSelect={handleSelectedFormatValues}
                                selectedValues={selectedFormatsList}
                                selectClass={selectedFormatsList.length > 0 ? "hightlight" : ""}
                            /></span>
                        </div>
                    </div>
                    <div id="row-content" className="row-1-content">
                        <div id="production-type-holder">
                            {console.log("allProdTypesData",allProdTypesData)}
                            <label id="production-type" className="production-type">{Globals.SIGNUP.PRODUCTION_TYPE_LABEL}</label>
                            <span tabIndex={11}><TitledCheckedDropDown
                                title={Globals.SIGNUP.COMPANY_PLACEHOLDERS.PRODUCTION_TYPE}
                                options={allProdTypesData}
                                onSelectAll={handleSelectAllProdTypes}
                                onSelect={handleSelectedProdTypeValues}
                                selectedValues={selectedProdTypeList}
                                selectClass={selectedProdTypeList.length > 0 ? "hightlight" : ""}
                            /></span>
                        </div>
                        <div id="channels-holder">
                            <label id="channels" className="channels">{Globals.SIGNUP.CHANNELS}</label>
                            <span tabIndex={12}><TitledCheckedDropDown
                                title={Globals.SIGNUP.CHANNELS_PLACEHOLDER}
                                options={allChannelsData}
                                onSelectAll={handleSelectAllChannels}
                                onSelect={handleSelectedChannelValues}
                                selectedValues={selectedChannelsList}
                                selectClass={selectedChannelsList.length > 0 ? "hightlight" : ""}
                            /></span>
                        </div>
                    </div>
                    <div className="seperator"></div>
                    <div>
                        <h3 id="basic-info" className="basic-info">{Globals.SIGNUP.CONTACT_INFO_LABEL}</h3>
                    </div>
                    <div id="row-content" className="row-1-content">
                        <div id="phone-number-holder">
                            <label id="phone-number" className="phone-number">{Globals.SIGNUP.COMPANY_CONTACT_NUM_LABEL}</label>
                            <input tabIndex={20} type="tel" pattern="[0-9+]+" id="phone-number-inp" className={`phone-number-inp ${companyContactNum && companyContactNum.length > 0 ? "hightlight" : ""}`} placeholder={Globals.SIGNUP.COMPANY_PLACEHOLDERS.COMPANY_CONTACT_NUM} onChange={handleCompanyContactNum} onBlur={checkCompanyContactNumber} maxLength={companyContactNum.charAt(0)==='+'?16:15} autoComplete='off'></input>
                            {isCompanyPhoneNumInValid && companyContactNum.length > 0 && <div><img id="login-error" className="login-error" src={Globals.IMG.ERROR} alt="password error" /><label className='invalidCredential'>{Globals.ERROR_MESSAGES.INVALID_PHONE_NUMBER}</label></div>}
                        </div>
                        <div id="email-holder">
                            <label id="email" className="email">{Globals.SIGNUP.COMPANY_EMAIL_LABEL}</label>
                            <input tabIndex={21} type="email" id="email-input" className={`email-input ${companyEmail && companyEmail.length > 0 ? "hightlight" : ""}`} placeholder={Globals.SIGNUP.COMPANY_PLACEHOLDERS.COMPANY_EMAIL} onChange={handleCompanyEmail} onBlur={validateCompanyEmail}autoComplete='off'></input>
                            {(isCompanyEmailInvalid && companyEmail.length > 0) && <div><img id="login-error" className="login-error" src={Globals.IMG.ERROR} alt="password error" /><label className='invalidCredential'>
                                {Globals.ERROR_MESSAGES.REG_INVALID_EMAIL}</label></div>}
                        </div>
                    </div>
                    <div id="row-content" className="row-1-content">
                        <div id="physical-address-holder">
                            <label id="physical-address" className="physical-address">{Globals.SIGNUP.COMPANY_ADDRESS}</label>
                            <span tabIndex={22}><TextArea placeHolder={Globals.SIGNUP.ADDRESS_PLACEHOLDER} textAreaInput={handleAddress} className={address && address.length > 0 ? "hightlight" : ""} /></span>
                        </div>
                        <div id="country-holder">
                            <label id="country" className="country">{Globals.SIGNUP.COUNTRY}</label>
                            <span tabIndex={23}><DropdownList options={allCountriesData} placeHolderValue={Globals.SIGNUP.COUNTRY_PLACEHOLDER} onSelect={handleCountry} selectClass={country && "hightlight"} /></span>
                        </div>
                        <div id="provience-holder">
                            <label id="provience" className="provience">{Globals.SIGNUP.PROVIENCE}</label>
                            <span tabIndex={24}><DropdownList options={provincesList} placeHolderValue={Globals.SIGNUP.PROVIENCE_PLACEHOLDER} onSelect={handleProvience} selectClass={provience && "hightlight"} valueToReset={country} /></span>
                        </div>
                    </div>

                    <div className="seperator"></div>

                    <div>
                        <h3 id="basic-info" className="basic-info">{Globals.SIGNUP.SATUTORY_INFO_LABEL}</h3>
                    </div>
                    <div id="row-content" className="row-1-content">
                        {/* <div id="vat-reg-num-holder">
                            <label id="vat-reg-num" className="vat-reg-num">{Globals.SIGNUP.VAT_REG_NUM_LABEL}</label>
                            <input tabIndex={13} type="text" id="vat-reg-num-inp" className={`vat-reg-num-inp ${vatRegNum && vatRegNum.length > 0 ? "hightlight" : ""}`} placeholder={Globals.SIGNUP.COMPANY_PLACEHOLDERS.VAT_REG_NUM} onChange={handleVatRegNum} onBlur={checkVatRegNum} maxLength={14}></input>
                            {(isVatRegNumInvalid || isVatRegNumExists) && <div><img id="login-error" className="login-error" src={Globals.IMG.ERROR} alt="password error" /><label className='invalidCredential'>{isVatRegNumInvalid?Globals.ERROR_MESSAGES.INVALID_VAT_REG_NUM:Globals.ERROR_MESSAGES.VAT_REG_NUM_EXISTS}</label></div>}
                        </div> */}
                        <div id="vendor-reg-holder">
                            <label id="vendor-reg" className="vendor-reg">{Globals.SIGNUP.VENDOR_REQUIRED}<span id="mandatory" className="mandatory">{Globals.MANDATORY_FIELD}</span></label>
                            <span><ConditionalUpload isUploadRequired={false} setOption={handleVendorReg} tabIndex1={14} tabIndex2={15} handleVendorRegNum={handleVendorRegNumber} /></span>
                        </div>
                        {isVendorRegNum && <div id="ven-reg-num-holder">
                            <label id="ven-reg-num" className="ven-reg-num">{Globals.SIGNUP.VEN_REG_NUM_LABEL}<span id="mandatory" className="mandatory">{Globals.MANDATORY_FIELD}</span></label>
                            <input type="text" id="ven-reg-num-inp" className={`ven-reg-num-inp ${venRegNum && venRegNum.length > 0 ? "hightlight" : ""}`} placeholder={Globals.SIGNUP.COMPANY_PLACEHOLDERS.VEN_REG_NUM} onChange={handleVenRegNum} onBlur={checkVenRegNum} onLoad={checkVenRegNum} maxLength={30} autoComplete='off'></input>
                            {(venRegNum.length===0) && <div><img id="login-error" className="login-error" src={Globals.IMG.ERROR} alt="password error" /><label className='invalidCredential'>{Globals.ERROR_MESSAGES.EMPTY_COMPANY_VENDOR_REG_NUM}</label></div>}
                            {(venRegNum.length > 0 && isVenRegNumExists) && <div><img id="login-error" className="login-error" src={Globals.IMG.ERROR} alt="password error" /><label className='invalidCredential'>{Globals.ERROR_MESSAGES.VENDOR_REG_NUM_EXISTS}</label></div>}
                        </div>}
                    </div>
                    <div id="row-content" className="row-1-content">
                        {!isVendorRegistered && (
                            <>
                                <div>
                                    <label id="upload-question" className="upload-question">{Globals.SIGNUP.VENDOR_REG_FILE_UPLOAD_CONTROLS.VAT_CLEARANCE_CERTIFICATE}</label>
                                    <div>
                                        <FileUploader onFileUpload={(file) => handleVendorRegControls('vatCert',file)} supportedFileType="All" isFromRegPage={true} />
                                    </div>
                                </div>
                                <div>
                                    <label id="upload-question" className="upload-question">{Globals.SIGNUP.VENDOR_REG_FILE_UPLOAD_CONTROLS.VAT_103}</label>
                                    <div>
                                        <FileUploader onFileUpload={(file) => handleVendorRegControls('vat103',file)} supportedFileType="All" isFromRegPage={true} />
                                    </div>
                                </div>
                                <div>
                                    <label id="upload-question" className="upload-question">{Globals.SIGNUP.VENDOR_REG_FILE_UPLOAD_CONTROLS.TAX_INVOICE}</label>
                                    <div>
                                        <FileUploader onFileUpload={(file) => handleVendorRegControls('taxInvoice',file)} supportedFileType="All" isFromRegPage={true} />
                                    </div>
                                </div>
                            </>
                            )}
                    </div>
                    <div id="row-content" className="row-1-content">
                        {!isVendorRegistered && (
                            <>
                                <div>
                                    <label id="upload-question" className="upload-question wrap-white-space">{Globals.SIGNUP.VENDOR_REG_FILE_UPLOAD_CONTROLS.REG_DOCS}</label>
                                    <div>
                                        <FileUploader onFileUpload={(file) => handleVendorRegControls('regDocs',file)} supportedFileType="All" isFromRegPage={true} />
                                    </div>
                                </div>
                                {country === 1 && (<div>
                                    <label id="upload-question" className="upload-question wrap-white-space">{Globals.SIGNUP.VENDOR_REG_FILE_UPLOAD_CONTROLS.VALID_BBEEE_CERTIFICATE}</label>
                                    <div>
                                        <FileUploader onFileUpload={(file) => handleVendorRegControls('bbbeeCert',file)} supportedFileType="All" isFromRegPage={true} />
                                    </div>
                                </div>)}
                                <div>
                                    <label id="upload-question" className="upload-question wrap-white-space">{Globals.SIGNUP.VENDOR_REG_FILE_UPLOAD_CONTROLS.BANK_STAMPED}</label>
                                    <div>
                                        <FileUploader onFileUpload={(file) => handleVendorRegControls('bankStamped',file)} supportedFileType="All" isFromRegPage={true} />
                                    </div>
                                </div>
                            </>
                            )}
                    </div>
                    {/* <div id="row-content" className="row-1-content">
                        <div id="tax-clearance-holder" className="tax-clearance-holder">
                            <label id="tax-clearance-ques" className="tax-clearance-ques">{Globals.SIGNUP.TAX_CERTIFICATE_QUESTION_LABEL}</label>
                            <span><ConditionalUpload isUploadRequired={true} setOption={handleTaxClearance} tabIndex1={16} tabIndex2={17} /></span>
                        </div>
                        <div id="upload-question-holder" className="upload-question-holder">
                            {isTaxClearance && (
                                <div>
                                    <label id="upload-question" className="upload-question">{Globals.SIGNUP.PLEASE_UPLOAD}<span id="mandatory" className="mandatory">{Globals.MANDATORY_FIELD}</span></label>
                                    <div>
                                        <FileUploader onFileUpload={(file)=>handleTaxCertificateFileInput(file)} supportedFileType="All" isFromRegPage={true}/>
                                        {(isTaxFilePresent===false)&&<div><img id="login-error" className="login-error" src={Globals.IMG.ERROR} alt="password error" /><label className='invalidCredential'>{Globals.ERROR_MESSAGES.EMPTY_TAX_FILE}</label></div>}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div> */}
                    {/* {country === 1 && (
                    <div id="row-content" className="row-1-content">
                        <div id="bbee-compliant-holder" className="bbee-compliant-holder">
                            <label id="bbee-compliant-ques" className="bbee-compliant-ques">{Globals.SIGNUP.BBEE_COMPLIANT_LABEL}</label>
                            <span><ConditionalUpload isUploadRequired={true} setOption={handleBBEECompliant} tabIndex1={18} tabIndex2={19} /></span>
                        </div>
                        <div id="upload-question-holder bbee-question" className="upload-question-holder bbee-question">
                            {isBBEECompliant && (
                                <div>
                                <label id="upload-question" className="upload-question">{Globals.SIGNUP.PLEASE_UPLOAD}<span id="mandatory" className="mandatory">{Globals.MANDATORY_FIELD}</span></label>
                             <div>
                             <FileUploader onFileUpload={(file)=>handleBBEEEFileInput(file)} supportedFileType="All" isFromRegPage={true} />
                             {(isBBBEEFilePresent===false)&&<div><img id="login-error" className="login-error" src={Globals.IMG.ERROR} alt="password error" /><label className='invalidCredential'>{Globals.ERROR_MESSAGES.EMPTY_BBEE_FILE}</label></div>}
                         </div>
                         </div>
                        )}
                        </div>
                    </div>
                     )} */}

            <div className="seperator"></div>

                    <span><TermsConditions checkForAgreement={handleAggreement} tabIndex1={25} /></span>
                </div>

            </div>
            <div>
            </div>
            <div>
                <span><RegisterFooter onCancelRegister={cancelRegistration} isButtonEnabled={isFormValid} onSubmit={processUserRegsitartion} tabIndex1={26} tabIndex2={27} /></span>
            </div>
            <div>
                {isRegCanceled && <div className='popup-bg'><Popup title={Globals.SIGNUP.POPUP.CANCEL.TITLE}
                    text={Globals.SIGNUP.POPUP.CANCEL.MESSAGE}
                    negativeAction={navigateBackToSignUp}
                    negativeActionText={Globals.SIGNUP.POPUP.CANCEL.BUTTON_TEXT}
                    popupType={"abort"}
                    onClose={() => setRegCancel(false)}
                    clearData={clearCheckedList}
                    resetPolicy={resetCheckBox}
                /></div>}
                {isRegFailed && <div className='popup-bg'><Popup title={Globals.SIGNUP.POPUP.FAILURE.TITLE}
                    text={Globals.SIGNUP.POPUP.FAILURE.MESSAGE}
                    normalAction={processUserRegsitartion}
                    normalActionText={Globals.SIGNUP.POPUP.FAILURE.BUTTON_TEXT}
                    popupType={"failed"}
                    onClose={() => setRegFailure(false)}
                // clearData={clearCheckedList}
                // resetPolicy={resetCheckBox}
                /></div>}
                {isRegSuccess && <div className='popup-bg'><Popup title={Globals.SIGNUP.POPUP.SUCCESS.TITLE}
                    text={''}
                    normalAction={navigateToLogin}
                    normalActionText={Globals.SIGNUP.POPUP.SUCCESS.BUTTON_TEXT}
                    popupType={"success"}
                    onClose={() => setRegSuccess(false)}
                    clearData={clearCheckedList}
                    resetPolicy={resetCheckBox}
                /></div>}
            </div>
            {loading && <ProgressLoader height={50} width={50} component={"company-reg-create"}/>}
        </div>
    )
}
export default CompanyRegistration;